import type { NormalizedDecisionMaker } from '../../../../../shared/types';

export const BREAKPOINT_THRESHOLD_LIST: Array<{ breakpoint: number; textLimit: number }> = [
	{ breakpoint: 1280, textLimit: 130 },
	{ breakpoint: 1024, textLimit: 90 },
	{ breakpoint: 768, textLimit: 75 },
	{ breakpoint: 640, textLimit: 100 },
	{ breakpoint: 0, textLimit: 40 },
];

export const getTextForScreenWidth = (response: NormalizedDecisionMaker['response'], screenWidth: number) => {
	const responseLength = response?.message.length || 0;

	for (const threshold of BREAKPOINT_THRESHOLD_LIST) {
		if (screenWidth >= threshold.breakpoint) {
			return {
				text:
					responseLength > threshold.textLimit
						? `${response?.message.substring(0, threshold.textLimit)}...`
						: response?.message,
				isTextLong: responseLength > threshold.textLimit,
			};
		}
	}

	return { text: response?.message, isTextLong: false };
};
